import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Box, Stack, Typography } from "@mui/material";
import { CONTRACT_UX } from "./contractUxTheme";

const ITEMS = [
  { icon: WorkOutlineIcon, label: "دریافت پروژه‌های جدید" },
  { icon: AssignmentOutlinedIcon, label: "مشاهده وضعیت پروژه" },
  { icon: TimelineOutlinedIcon, label: "ثبت پیشرفت پروژه" },
  { icon: PaymentsOutlinedIcon, label: "ارسال درخواست پرداخت" },
];

/**
 * Phase 7.7.4 — Compact benefits strip after activation path.
 */
const ContractPostActivationCard = ({ visible = true }) => {
  if (!visible) return null;

  return (
    <Box
      data-testid="contract-post-activation-card"
      dir="rtl"
      sx={{
        borderRadius: 2,
        border: `1.5px dashed ${CONTRACT_UX.cardBorder}`,
        bgcolor: "#fff",
        px: CONTRACT_UX.cardPadding,
        py: 1.75,
      }}
    >
      <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1.25 }}>
        پس از فعال‌سازی می‌توانید:
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        justifyContent="space-between"
      >
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <Stack
              key={item.label}
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ flex: 1 }}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: 1,
                  bgcolor: "rgba(0,91,143,0.08)",
                  color: CONTRACT_UX.primary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon sx={{ fontSize: 18 }} />
              </Box>
              <Typography variant="body2" fontWeight={600}>
                {item.label}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};

export default ContractPostActivationCard;
